module.exports = __webpack_public_path__ + "static/img/bg-ar.7312b120.webp";